import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import find from 'lodash.find';

import CertificateDownloadForm from './CertificateDownloadForm';
import CustomDialog from '../dialogs/CustomDialog';
import TwoStepsDownloadButton from '../../misc/TwoStepsDownloadButton';

import GenerateEventCertificateMutation from '../../../mutations/GenerateEventCertificateMutation';

import environment from '../../../environment';

const ThumbnailPreviewCertificateDownload = (props) => {
  const { photoNodeId, startNumbers, intl, isFaceSearchEvent, eventSgId } = props;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [failed, setFailed] = useState(false);

  const closeDialog = () => {
    setDialogOpen(false);
  };

  const openDialog = () => {
    setDialogOpen(true);
  };

  const handleDownloadCertificate = (startNumber) => {
    addToPendingArray(startNumber);

    GenerateEventCertificateMutation.commit(
      environment,
      eventSgId,
      photoNodeId,
      startNumber,
      (error, url) => {
        if (!error) {
          setFailed(false);
          download(url);
        } else {
          setFailed(true);
        }
        removeFromPendingArray(startNumber);
      }
    );
  };

  const download = (url) => {
    window.location.href = url;
  };

  const addToPendingArray = (startNumber) => {
    let newArr = [...pendingRequests];
    newArr.push(startNumber);
    setPendingRequests(newArr);
  };

  const removeFromPendingArray = (startNumber) => {
    const newArr = pendingRequests.filter((item) => item !== startNumber);
    setPendingRequests(newArr);
  };

  return (
    <div>
      {startNumbers &&
        !isFaceSearchEvent &&
        startNumbers.map((sn) => {
          return (
            <TwoStepsDownloadButton
              key={sn}
              requestLabel={intl.formatMessage(
                translations.downloadCertificateForStartnumberButton,
                {
                  startNumber: sn,
                }
              )}
              isPending={pendingRequests.includes(sn)}
              onRequest={() => handleDownloadCertificate(sn)}
            />
          );
        })}
      {isFaceSearchEvent && (
        <div>
          <TwoStepsDownloadButton
            requestLabel={intl.formatMessage(translations.downloadCertificateButton)}
            isPending={false}
            onRequest={openDialog}
          />
          <CustomDialog open={dialogOpen} onRequestClose={closeDialog}>
            <CertificateDownloadForm
              onDownloadCertificate={handleDownloadCertificate}
              pendingRequests={pendingRequests}
              failed={failed}
            />
          </CustomDialog>
        </div>
      )}
    </div>
  );
};

const translations = defineMessages({
  generateCertificateButton: {
    id: 'thumbnailPreviewAccountDetails.actions.generateCertificate',
    defaultMessage: 'Generate certificate for No. {startNumber}',
  },
  downloadCertificateForStartnumberButton: {
    id: 'thumbnailPreviewAccountDetails.actions.downloadCertificateForStartnumber',
    defaultMessage: 'Download certificate for No. {startNumber}',
  },
  downloadCertificateButton: {
    id: 'thumbnailPreviewAccountDetails.actions.downloadCertificate',
    defaultMessage: 'Download certificate',
  },
});

ThumbnailPreviewCertificateDownload.propTypes = {
  photoNodeId: PropTypes.string,
  startNumbers: PropTypes.array,
  intl: PropTypes.object,
  isFaceSearchEvent: PropTypes.bool,
  eventSgId: PropTypes.number,
};

export default injectIntl(ThumbnailPreviewCertificateDownload);
export { ThumbnailPreviewCertificateDownload };

